import xss from 'xss';

export enum JOIN_STATUS {
  NOT_JOINED = 'NOT_JOINED',
  JOINED_AS_REGISTRANT = 'JOINED_AS_REGISTRANT',
  JOINED_AS_REGULAR = 'JOINED_AS_REGULAR',
  REGISTRATION_FULL = 'REGISTRATION_FULL',
}

export enum TIME_RANGES {
  MINUTES_IN_HOUR = 60,
  SECONDS_IN_MINUTE = 60,
  MILLISECONDS_IN_SECOND = 1000,
  MILLISECONDS_IN_MINUTE = 60000,
  MILLISECONDS_IN_HOUR = 3600000,
}

export enum TIME_FORMATS {
  Clock_Format_12hr = "h:mm aaaaa'm'",
  Clock_Format_24hr = "HH:mm",
  Event_Start_Date_Long_US = "EEEE, MMMM d, yyyy",
  Event_End_Date_Long_US = "EEEE, MMMM d, yyyy",
  Event_Start_Date_Long_UK = "EEEE, d MMMM yyyy",
  Event_End_Date_Long_UK = "EEEE, d MMMM yyyy",
  Event_Start_Day_D = "d",
  Event_End_Day_D = "d",
  Event_Start_Day_DD = "dd",
  Event_End_Day_DD = "dd",
  Event_Start_Day_DDD = "EEE",
  Event_End_Day_DDD = "EEE",
  Event_Start_Day_DDDD = "EEEE",
  Event_End_Day_DDDD = "EEEE",
  Event_Start_Month_M = "M",
  Event_End_Month_M = "M",
  Event_Start_Month_MM = "MM",
  Event_End_Month_MM = "MM",
  Event_Start_Month_MMM = "MMM",
  Event_End_Month_MMM = "MMM",
  Event_Start_Month_MMMM = "MMMM",
  Event_End_Month_MMMM = "MMMM",
  Event_Start_Year_YY = "yy",
  Event_End_Year_YY = "yy",
  Event_Start_Year_YYYY = "yyyy",
  Event_End_Year_YYYY = "yyyy",
  default = "EEEE, MMMM d, yyyy"
}

export enum TEMPLATE_VARIABLES {
  Event_Name = 'Event_Name',
  Event_Starttime12hr = 'Event_Starttime12hr',
  Event_Endtime12hr = 'Event_Endtime12hr',
  Event_Starttime24hr = 'Event_Starttime24hr',
  Event_Endtime24hr = 'Event_Endtime24hr',
  Event_Start_Date_Long_US = 'Event_Start_Date_Long_US',
  Event_Start_Date_Long_UK = 'Event_Start_Date_Long_UK',
  Event_Start_Day_D = 'Event_Start_Day_D',
  Event_Start_Day_DD = 'Event_Start_Day_DD',
  Event_Start_Day_DDD = 'Event_Start_Day_DDD',
  Event_Start_Day_DDDD = 'Event_Start_Day_DDDD',
  Event_Start_Month_M = 'Event_Start_Month_M',
  Event_Start_Month_MM = 'Event_Start_Month_MM',
  Event_Start_Month_MMM = 'Event_Start_Month_MMM',
  Event_Start_Month_MMMM = 'Event_Start_Month_MMMM',
  Event_Start_Year_YY = 'Event_Start_Year_YY',
  Event_Start_Year_YYYY = 'Event_Start_Year_YYYY',
  Event_End_Date_Long_US = 'Event_End_Date_Long_US',
  Event_End_Date_Long_UK = 'Event_End_Date_Long_UK',
  Event_End_Day_D = 'Event_End_Day_D',
  Event_End_Day_DD = 'Event_End_Day_DD',
  Event_End_Day_DDD = 'Event_End_Day_DDD',
  Event_End_Day_DDDD = 'Event_End_Day_DDDD',
  Event_End_Month_M = 'Event_End_Month_M',
  Event_End_Month_MM = 'Event_End_Month_MM',
  Event_End_Month_MMM = 'Event_End_Month_MMM',
  Event_End_Month_MMMM = 'Event_End_Month_MMMM',
  Event_End_Year_YY = 'Event_End_Year_YY',
  Event_End_Year_YYYY = 'Event_End_Year_YYYY',
  Event_Time_Zone = 'Event_Time_Zone'
}

export const timezonesConvertor: Record<string, string> = {
  'Pacific/Midway': 'ST',
  'Pacific/Honolulu': 'HST',
  'America/Anchorage': 'AKT',
  'America/Los_Angeles': 'PT',
  'America/Mazatlan': 'MT',
  'America/Phoenix': 'MT',
  'America/Denver': 'MT',
  'America/Guatemala': 'CT',
  'America/Mexico_City': 'CT',
  'America/Regina': 'CT',
  'America/Bogota': 'COT',
  'America/Chicago': 'CT',
  'America/Caracas': 'VET',
  'America/Indianapolis': 'ET',
  'America/New_York': 'ET',
  'America/Argentina/Buenos_Aires': 'ART',
  'America/Santiago': 'CLT',
  'America/Sao_Paulo': 'BRT',
  'America/St_Johns': 'NT',
  'America/Godthab': 'WGT',
  'Atlantic/Cape_Verde': 'CVT',
  'Atlantic/Azores': 'AZOT',
  'Africa/Algiers': 'CET',
  'Africa/Casablanca': 'WET',
  'Europe/London': 'UKT',
  'Africa/Harare': 'CAT',
  'Europe/Amsterdam': 'CET',
  'Europe/Belgrade': 'CET',
  'Europe/Brussels': 'CET',
  'Europe/Warsaw': 'CET',
  'Africa/Cairo': 'EET',
  'Africa/Nairobi': 'EAT',
  'Asia/Baghdad': 'AT',
  'Asia/Jerusalem': 'IT',
  'Asia/Kuwait': 'AT',
  'Europe/Athens': 'EET',
  'Europe/Bucharest': 'EET',
  'Europe/Helsinki': 'EET',
  'Europe/Moscow': 'MT',
  'Asia/Tehran': 'IRT',
  'Asia/Baku': 'AZT',
  'Asia/Dubai': 'GT',
  'Asia/Kabul': 'AFT',
  'Asia/Almaty': 'ALMT',
  'Asia/Tashkent': 'UZT',
  'Asia/Yekaterinburg': 'YEKT',
  'Asia/Calcutta': 'IT',
  'Asia/Kolkata': 'IT',
  'Asia/Kathmandu': 'NPT',
  'Asia/Dhaka': 'BDT',
  'Asia/Rangoon': 'MMT',
  'Asia/Bangkok': 'ICT',
  'Asia/Krasnoyarsk': 'KRAT',
  'Asia/Irkutsk': 'IRKT',
  'Asia/Kuala_Lumpur': 'MYT',
  'Asia/Shanghai': 'CT',
  'Asia/Taipei': 'CT',
  'Australia/Perth': 'AWT',
  'Asia/Seoul': 'KT',
  'Asia/Tokyo': 'JT',
  'Asia/Yakutsk': 'YAKT',
  'Australia/Adelaide': 'ACT',
  'Australia/Darwin': 'ACT',
  'Asia/Vladivostok': 'VLAT',
  'Australia/Brisbane': 'AET',
  'Australia/Hobart': 'AET',
  'Australia/Sydney': 'AET',
  'Pacific/Port_Moresby': 'PGT',
  'Asia/Magadan': 'MAGT',
  'Pacific/Auckland': 'NZT',
  'Pacific/Fiji': 'FJT',
  'Pacific/Apia': 'WST',
};

export const ARRAY_INCREMENT_SIZE = 1;
export const COMPARE_INDEX = 1;
export const MAX_TIMEOUT = 2147483647;

export const OE_TEXT_LABEL = 'OpenExchange';
export const OE_LOGO_IMG_PATH = '/img/OE_Logo.svg';
export const OE_LOGO_ALT_TEXT = `${OE_TEXT_LABEL} Logo`;
export const POWERED_BY_ALT_TEXT = 'Powered by OpenExchange';
export const PASSCODE_EXPIRATION_DAYS = 7;

export const
  PASSCODE_KEY = 'passcode',
  BYPASS_TOKEN_KEY = 'token',
  ATTENDEE_TOKEN_KEY = 'attendeeToken',
  MEET_PATH_KEY = 'meetingPath',
  MEETING_LINK_PATH_KEY = 'meetingLinkPath',
  MEETING_LINK_DEVICE_TOKEN_KEY_PREFIX = 'meetingLinkDeviceToken:',
  MEET_ID_KEY = 'meetingId',
  JOIN_METHOD_ID_KEY = 'joinMethodId',
  EVENT_ID_KEY = 'eventId',
  ML_ACCESS_TOKEN = 'ml_access_token',
  TYPE = 'type',
  TOKEN = 'token',
  SINGLE_MEETING_PATH = 'singleMeetingPath',
  FORM_VIEW = 'form_view',
  FILTER_REPLAYS = 'filterReplays',
  SUBSCRIBE_TO_EVENT = 'subscribeToEvent',
  CODE = 'code',
  STATE = 'state',
  LOCALE= 'locale',
  USER_STATE= 'userState',
  PLAYER_ONLY= 'playeronly'
;

/* DEFAULTS */
export const
  BACKGROUND_IMG_URL = '/img/OE_Background.jpg',
  DEFAULT_BACKGROUND_IMG_ULT_TEXT = 'Background image',
  PRIMARY_COLOR = '#00787A',

  ERR_MSG = 'Incorrect email address or access code.',
  REQUEST_ACCESS_CODE = 'REQUEST_ACCESS_CODE',
  REGISTRATION = 'REGISTRATION',
  RADIUS_SPINNER = 40,
  RADIUS_STROKE = 2,
  COLOR_SPINNER = '#000000',
  DEVIDER_BY_TWO = 2,
  HALF_A_MINUTE_IN_MILLISECONDS = TIME_RANGES.MILLISECONDS_IN_MINUTE / DEVIDER_BY_TWO,
  INPUT_DEBOUNCE_TIME = 350
;

/* KNOVIO */
export enum KvEmbedType { SHOWCASE = 'showcase', PRESENTATION = 'presentation' }
export const
  SECURE_PROTO = 'https',
  SHOWCASE = 'showcase',
  EMBED = 'embed',
  THUMBNAIL = 'thumbnail',
  PRESENTATION = 'presentation',
  EMBEDDED_CONTENT = 'KnowledgeVisionEmbeddedContent'
;

// StringValidators
export const REQUIRED = (v: string): boolean => Boolean(v);
// CheckBoxValidators
export const REQUIRED_CHECKBOX = (v: string): boolean => v === 'TRUE';
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const MIN6CHAR = (v = '', len = 6): boolean => v.length >= len;
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const SHORT_PLAIN_TEXT_LENGTH = (v = '', len = 255): boolean => v.length <= len;
export const MEDIUM_PLAIN_TEXT_LENGTH = (v = '', len = MEDIUM_PLAIN_TEXT_MAX_LENGTH): boolean => v.length <= len;
// eslint-disable-next-line
export const EMAIL_REGEXP = (v = ''): boolean => v ? /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v) : true;
export const NO_XSS_CONTENT = (v = ''): boolean => {
  if (!v) return true;

  // Use xss library to detect XSS by comparing original with sanitized version
  // Configure xss to strip all HTML tags and attributes
  const sanitized = xss(v, {
    whiteList: {}, // No allowed tags
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style']
  });

  // If sanitized version is different from original, it contained XSS
  return sanitized === v;
};
export const SPACE_TRIMMER = (v = ''): string => String.prototype.trim.apply(v);
export const FIRST_SPACE_TRIMMER = (v = ''): string => String.prototype.trimStart.apply(v);
export const SESSION_MEETING_PATH_REGEX = /session\/\d+\/meeting\/\d+/;
export const AGENDA_MEETING_PATH_REGEX = /agenda\/\d+\/meeting\/\d+/;
export const STRING_WITHOUT_HTML_REGEX = /<[^>]*>?/g;
export const STRING_WITH_HYPHEN_REGEX = /(.{3})(?=.)/g;
export const HTML_TAG_REGEX = /<[^>]*>/g;
export const MULTIPLE_WHITESPACE_REGEX = /\s+/g;
interface IAutoCompleteValues {
  [key: string]: string
}

export const AUTO_COMPLETE_VALUES: IAutoCompleteValues = {
  firstName: 'given-name',
  lastName: 'family-name',
  organizationName: 'organization',
  salutation: 'on',
  phone: 'tel-local',
  title: 'on',
  email: 'email',
};

export const ATTENDEE_COLLAPSED_BIO_MAX_HEIGHT = 60;
export const REPLAY_TILE_LEFTOVER_CONTENT_HEIGHT = 130;
export const FEATURED_TILE_LEFTOVER_CONTENT_HEIGHT = 100;
export const NEXT_TILE_LEFTOVER_CONTENT_HEIGHT = 140;
export const FEATURE_CONTENT_HIGHT_BEFORE_EXPAND = 154;
export const REPLAYS_CONTENT_HIGHT_BEFORE_EXPAND = 235;
export const MEDIUM_PLAIN_TEXT_MAX_LENGTH = 2048;

export enum CheckBoxValues {
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}

export const CheckBoxMapper: { [key: string]: boolean } = {
  [`${CheckBoxValues.TRUE}`]: true,
  [`${CheckBoxValues.FALSE}`]: false
};

export const COOKIE_NOTIFICATION_KEY = 'cookieNotification';
export const COOKIE_NOTIFICATION_EXPIRATION_DAYS = 180;

export enum ItemCounts {
  ZERO,
  ONE,
  TWO,
  THREE,
  FOUR,
}

export const REG_DATA = 'REG_DATA';

export const ERR_MODAL_COMMON_STYLES = {
  overlay: {
    zIndex: 9,
    background: 'rgba(255,255,255, 0.6)'
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '40px',
    width: '500px',
    boxShadow: '6px 6px 20px 0 rgba(0, 0, 0, 0.3)',
  }
};

export enum ONE_TAP_FORMULA {
  PHONE_NUMBER = '{telephone_number}',
  CONFERENCE_ID = '{conference_id}',
  PARTICIPANT_ID = '{participant_id}',
  PASSCODE = '{passcode}',
}

export const CONNECT_TO_MEETING_LABEL = 'Connect to Meeting';
export const LIST_ALLOWED_CONNECTIONS = ['ZOOM', 'WEBINAR','WEBEX', 'TEAMS', 'BLUEJEANS', 'OTHER'];

export const ERROR_SUBDOMAIN = 'error';
export const ERROR_MESSAGE = 'Something went wrong. Please contact the event coordinator.';
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const CALENDAR_ADD_ERROR_MESSAGE = "We're sorry we couldn't send the calendar invite. Please try again.";
export const INVALID_SSO_URL = 'Invalid SSO login URL';
export const SSO_NOT_CONFIGURED = 'SSO is not configured for this account';

export const HOSTED_BY = 'Hosted By:';
export const MATCHED_KEY_INDEX = 0;

export enum CALENDAR_INVITES {
  subscribe = 'SUBSCRIBE_TO_CALENDAR',
  Download = 'DOWNLOAD_CALENDAR_FILES',
  Both = 'BOTH'
}

export enum PassportNonce {
  CUSTOM_CSS='OePassportCustomCss',
  RICH_TEXT='OePassportRichText',
}

export enum BookableStatus {
  BOOKABLE = 'BOOKABLE',
  JOIN_AS_PARTICIPANT = 'JOIN_AS_PARTICIPANT',
  JOIN_AS_NON_PARTICIPANT = 'JOIN_AS_NON_PARTICIPANT',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum RegistrationStatus {
  PENDING = 'PENDING',
  DENIED = 'DENIED',
  APPROVED = 'APPROVED'
}

export const BOOKING_MESSAGES = {
  SUCCESS: 'You have successfully booked a meeting',
  CANCELLATION_SUCCESS: 'You have successfully Cancelled your Meeting Booking.',
  BOOKING_CONFIRM: 'Please confirm that you would like to book this meeting:',
  CANCELLATION_CONFIRM: 'Are you sure you want to',
  CANCELLATION_CONFIRM_BOLD: 'Cancel',
  CANCELLATION_CONFIRM_SUFFIX: 'this Meeting Booking?',
  FAILURE_UNAVAILABLE: 'Unfortunately, the meeting time you selected has become unavailable.',
  FAILURE_GENERIC: 'Unfortunately, we\'re not able to confirm your booking for this meeting.',
  FAILURE_CANCELLATION: 'Unfortunately, at the moment we\'re not able to cancel your booking for this meeting.',
  FAILURE_SECONDARY_UNAVAILABLE: 'Please try booking a different meeting.',
  FAILURE_SECONDARY_GENERIC: 'Please contact the event coordinator for further assistance.',
  FAILURE_SECONDARY_CANCELLATION: 'Please try again. If the issue persists, please contact the event coordinator for further assistance.',
  CALENDAR_INVITE_SENT: 'We have sent you a calendar invite.',
  LOADING_BOOKING: 'Booking your meeting...',
  LOADING_CANCELLATION: 'Cancelling your booking…'
} as const;

export const BOOKING_BUTTON_LABELS = {
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  DONE: 'Done',
  KEEP_BOOKING: 'No, Keep this Booking',
  CONFIRM_CANCELLATION: 'Yes, Cancel this Booking',
  CANCEL_BOOKING: 'Cancel Booking'
} as const;

export enum ModalMode {
  BOOK = 'book',
  CANCEL = 'cancel'
}

export enum FailureType {
  CANCELLATION = 'cancellation',
  UNAVAILABLE = 'unavailable',
  GENERIC = 'generic',
  OPEN_MEETING_FULL = 'openMeetingFull',
}

export const OPEN_MEETING_MESSAGES = {
  FULL: 'This meeting is now full.',
  REGISTERING: 'Registering...',
  REGISTRATION_FAILURE: 'We\'re sorry, this meeting is now full. Please refresh the page to see the most up-to-date information.',
} as const;

export const FAILURE_MESSAGES: Record<FailureType, { main: string; secondary: string }> = {
  [FailureType.CANCELLATION]: {
    main: BOOKING_MESSAGES.FAILURE_CANCELLATION,
    secondary: BOOKING_MESSAGES.FAILURE_SECONDARY_CANCELLATION
  },
  [FailureType.UNAVAILABLE]: {
    main: BOOKING_MESSAGES.FAILURE_UNAVAILABLE,
    secondary: BOOKING_MESSAGES.FAILURE_SECONDARY_UNAVAILABLE
  },
  [FailureType.GENERIC]: {
    main: BOOKING_MESSAGES.FAILURE_GENERIC,
    secondary: BOOKING_MESSAGES.FAILURE_SECONDARY_GENERIC
  },
  [FailureType.OPEN_MEETING_FULL]: {
    main: OPEN_MEETING_MESSAGES.REGISTRATION_FAILURE,
    secondary: '',
  },
};

export const delay = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));
export const ITEMS_IN_SINGLE_ROW = 3;

export const THIRTY_SECONDS_TIMEOUT = 30*1000;
export const TWO_MINUTE_TIMEOUT = 2*60*1000;

/* Delay before subscription fallback polling kicks in */
export const MEETING_REGISTRATION_FALLBACK_DELAY = 20*1000;
export const REGISTRATION_FALLBACK_DELAY = 60*1000;

/* Polling budget left after the fallback delay — the delay must stay below the flow's overall timeout, or polling is cancelled before its first attempt */
export const MEETING_REGISTRATION_POLLING_WINDOW = THIRTY_SECONDS_TIMEOUT - MEETING_REGISTRATION_FALLBACK_DELAY;
export const REGISTRATION_POLLING_WINDOW = TWO_MINUTE_TIMEOUT - REGISTRATION_FALLBACK_DELAY;
